import {
  ON,
  OFF,
  PZ_TIER_ONE_SUPPORT_ENABLED,
  PZ_TIER_ONE_CLIENT_SUPPORT_NUMBER,
  PZ_TIER_ONE_PAYER_SUPPORT_NUMBER,
  PZ_TIER_ONE_SUPPORT_CONTACT_NAME,
  PZ_TIER_ONE_SUPPORT_CONTACT_PHONE,
  TIER_ONE_SUPPORT_ENABLED_OFF_ON,
} from 'consts';

export { ON, OFF, TIER_ONE_SUPPORT_ENABLED_OFF_ON };
export {
  PZ_TIER_ONE_CLIENT_SUPPORT_NUMBER,
  PZ_TIER_ONE_PAYER_SUPPORT_NUMBER,
  PZ_TIER_ONE_SUPPORT_CONTACT_NAME,
  PZ_TIER_ONE_SUPPORT_CONTACT_PHONE,
};

export const Fields = {
  tierOneSupportEnabled: {
    name: TIER_ONE_SUPPORT_ENABLED_OFF_ON,
    label: 'Enabled',
  },
  supportContactPhone: {
    name: PZ_TIER_ONE_SUPPORT_CONTACT_PHONE,
    label: 'Payrailz Financial Support #',
  },
  supportContactName: {
    name: PZ_TIER_ONE_SUPPORT_CONTACT_NAME,
    label: 'Payrailz Financial Support Admin Contact',
  },
  clientSupportNumber: {
    name: PZ_TIER_ONE_CLIENT_SUPPORT_NUMBER,
    label: 'Client Support Number',
  },
  payerSupportNumber: {
    name: PZ_TIER_ONE_PAYER_SUPPORT_NUMBER,
    label: 'Payer Support Number',
  },
};

const toBooleanValue = (value) => ['1', 1, true, 'true'].includes(value);

export const getInitialValues = (fspConfigValues) => {
  const configArray = Array.isArray(fspConfigValues) ? fspConfigValues : [];

  const find = (key) =>
    configArray.find(
      (cv) => (cv?.valueItem?.configKey || cv?.configKey) === key
    );
  const valueOf = (cv) => cv?.valueItem?.configValue ?? cv?.configValue ?? '';

  const isEnabled = toBooleanValue(valueOf(find(PZ_TIER_ONE_SUPPORT_ENABLED)));
  return {
    [TIER_ONE_SUPPORT_ENABLED_OFF_ON]: isEnabled ? ON : OFF,
    [PZ_TIER_ONE_CLIENT_SUPPORT_NUMBER]: valueOf(
      find(PZ_TIER_ONE_CLIENT_SUPPORT_NUMBER)
    ),
    [PZ_TIER_ONE_PAYER_SUPPORT_NUMBER]: valueOf(
      find(PZ_TIER_ONE_PAYER_SUPPORT_NUMBER)
    ),
    [PZ_TIER_ONE_SUPPORT_CONTACT_NAME]: valueOf(
      find(PZ_TIER_ONE_SUPPORT_CONTACT_NAME)
    ),
    [PZ_TIER_ONE_SUPPORT_CONTACT_PHONE]: valueOf(
      find(PZ_TIER_ONE_SUPPORT_CONTACT_PHONE)
    ),
  };
};
